<div class="card">
  <div class="card-header d-flex justify-content-between">
    <h4 class="card-title text-primary">
      Project Deadlines
    </h4>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th style="min-width: 250px">Name</th>
                <th style="min-width: 250px">Due Date</th>
                <th style="min-width: 250px">Remaining Time</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let record of records">
                <td>{{ record.name }} ({{ record.type | uppercase }})</td>
                <td>{{ record.dueDate }}</td>
                <td>{{ record.remaining }} Hour(s)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
